<template>
  <DashboardWidget 
    :title="`NCR Cost For ${currentMonthName}`"
    icon="fa-usd-circle"
    widgetBackgroundClass="widget-bg5">
    <template v-slot:value>
      {{summaryData.ncrItemTotalValue | formatCurrency}}
    </template>
    <template v-slot:subValue>
      {{summaryData.ncrTotalCount}} NCR order{{summaryData.ncrTotalCount | displayCountPlural}}, {{summaryData.ncrItemValuePercent | formatPercent}} of ordered item value
    </template>
  </DashboardWidget>
</template>

<script>
import moment from 'moment'
import DashboardWidget from '@/components/dashboard/dashboardWidget'

export default {
  name: 'StationMonthlyNCRWidget',
  components: {
    DashboardWidget
  },
  props: {
    startDate: String,
    summaryData: Object
  },
  computed: {
    currentMonthName() {
      return moment(this.startDate).local().format('MMMM')
    }
  }  
}
</script>